import { CbBankBeneficialOwner } from 'cbbank/inquiry/fields';
import { PropertiesToString } from 'new/form/common/types';
import { AssociatedPersonSource } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/types';

export type BeneficialOwner = {
  id: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  nationality: string | undefined;
  capitalOrVotingRightsPercentage: number | undefined;
  placeOfResidence: string | undefined;
  countryOfResidence: string | undefined;
  birthPlace: string | undefined;
  birthDate: Date | undefined;
  fictional: boolean | undefined;
};

type PortalBeneficialOwnerAttributes = {
  source: AssociatedPersonSource;
  potentiallyManipulated: boolean;
  scope: string;
};

export type PortalBeneficialOwner = BeneficialOwner & PortalBeneficialOwnerAttributes;

export type CbBankPortalBeneficialOwner = CbBankBeneficialOwner & PortalBeneficialOwnerAttributes;

export const beneficialOwnerFields: PropertiesToString<BeneficialOwner> = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  nationality: 'nationality',
  capitalOrVotingRightsPercentage: 'capitalOrVotingRightsPercentage',
  placeOfResidence: 'placeOfResidence',
  countryOfResidence: 'countryOfResidence',
  birthPlace: 'birthPlace',
  birthDate: 'birthDate',
  fictional: 'fictional',
};
